<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>

      <v-card style="margin-bottom: 50px;">
        <v-container>
          <v-card-title>発注依頼内容</v-card-title>

          <v-layout row wrap>
            <v-flex xs12>
              <p class="text-sm-left title">{{ storeName }}</p>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <p class="text-sm-left title">{{ orderCreatedUser }}</p>  
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 sm6>
              <p class="text-sm-left title">店着日: {{ orderConfirmSelectedShippingDate }}</p>
            </v-flex>
          </v-layout>

          <v-divider></v-divider>
          <div style="height: 20px;"></div>
          <v-layout 
            row 
            wrap 
            v-if="!isZumiUser && region1IsLocked === '0' && region2IsLocked === '0'"
          >
            <v-menu
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              full-width
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-flex xs12 sm3>
                  <v-text-field
                    v-model="changedShippingDate"
                    :label="$t('sales.store-arrival-day')"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </v-flex>
              </template>
              <v-date-picker
                v-model="shippingDateForPicker"
                @input="menu2 = false"
                locale="jp-ja"
                :day-format="date => new Date(date).getDate()"
                no-title
                @change="changeShippingDate()"
              ></v-date-picker>
            </v-menu>

            <v-flex xs12 sm2 align-self-center style="margin-left: 10px;">
              <v-btn block color="success" dark @click="updateShippingDate()">
                <v-icon dark left>update</v-icon>店着日変更
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap reverse>
            <v-flex xs3 sm3 v-if="!isZumiUser && hasImage">
              <v-btn block color="primary" dark @click="downloadOrderImage()">
                <v-icon dark left>get_app</v-icon>画像ダウンロード
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap reverse>
            <v-flex xs3 sm3 v-if="!isZumiUser && !hasImage">
              <v-btn block color="primary" dark @click="copyOrderRequest()">
                <v-icon dark left>get_app</v-icon>発注数一括コピー（千葉）
              </v-btn>
            </v-flex>
          </v-layout>

          <v-flex xs12 sm4 md4>
            <v-switch label="発注依頼商品のみ" color="info" hide-details v-model="isOrderedItems"></v-switch>
          </v-flex>

          <v-data-table
            :headers="headers"
            :items="orderDetails"
            class="elevation-1"
            hide-actions
            style="margin: 30px 0;"
            :customFilter="customFilter"
            :search="isOrderedItems"
            disable-initial-sort
          >
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ props.header.text }}</span>
                </template>
                <span>{{ props.header.text }}</span>
              </v-tooltip>
            </template>
            <template v-slot:items="props">
              <tr
                v-bind:class="{
                  'changed-class-name-order-accept': props.item.isChanged,
                  'changed-over-class-name-order-accept':
                    props.item.orderLimitNumber <
                      parseInt(props.item.region1) +
                        parseInt(props.item.region2) ||
                    props.item.region1 < 0 ||
                    props.item.region2 < 0
                }"
              >
                <!-- 상품명 -->
                <td class="text-xs-left px-3">
                  <v-tooltip top>
                    <template #activator="{ on }">
                      <div v-on="on">{{ props.item.itemName }}</div>
                    </template>
                    <span>{{ props.item.janCode }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-right px-3">{{ props.item.quantity }}</td>
                <td class="text-xs-right px-3">{{ props.item.numberOfStocks }}</td>
                <td class="text-xs-right px-3">{{ props.item.orderLimitNumber }}</td>
                <td class="text-xs-right px-3">
                  {{
                  parseInt(props.item.region1) + parseInt(props.item.region2)
                  }}
                </td>
                <td
                  class="text-xs-right px-3"
                  v-bind:class="{ 'region-is-locked': region1IsLocked === '1' }"
                >
                  <input
                    type="number"
                    name="iron1Name[]"
                    v-model.number="props.item.region1"
                    class="column-input-for-order"
                    :disabled="isZumiUser || region1IsLocked === '1'"
                    min="0"
                    @change="onChangeRegion(props.item)"
                  />
                </td>
                <td
                  class="text-xs-right px-3"
                  v-bind:class="{ 'region-is-locked': region2IsLocked === '1' }"
                >
                  <input
                    type="number"
                    name="iron1Name[]"
                    v-model.number="props.item.region2"
                    class="column-input-for-order"
                    :disabled="isZumiUser || region2IsLocked === '1'"
                    min="0"
                    @change="onChangeRegion(props.item)"
                  />
                </td>
                <td class="text-xs-left px-3">
                  <v-flex 
                    xs3 
                    sm3 
                    v-if="!isZumiUser && '0' === region1IsLocked && '0' === region2IsLocked"
                  >
                    <v-btn
                      block
                      color="error"
                      dark
                      @click="clearOrderDetail(props.item)"
                      v-bind:disabled="
                        0 === props.item.quantity ||
                          (0 === props.item.region1 && 0 === props.item.region2)
                      "
                    >
                      <v-icon dark left>settings_backup_restore</v-icon>クリア
                    </v-btn>
                  </v-flex>
                </td>
              </tr>
            </template>
          </v-data-table>

          <v-layout row wrap reverse v-if="!isZumiUser">
            <v-flex xs12 sm3 style="margin-right: 20px;">
              <v-btn
                block
                color="#424242"
                dark
                @click="lockRegion2()"
                v-if="this.region2IsLocked === '0'"
              >
                <v-icon dark left>lock</v-icon>千葉をロックする
              </v-btn>
              <v-btn block color="#424242" dark @click="lockRegion2()" v-else>
                <v-icon dark left>lock_open</v-icon>千葉のロックを解除する
              </v-btn>
            </v-flex>
            <v-flex xs12 sm3 style="margin-right: 30px;">
              <v-btn
                block
                color="#424242"
                dark
                @click="lockRegion1()"
                v-if="this.region1IsLocked === '0'"
              >
                <v-icon dark left>lock</v-icon>三田をロックする
              </v-btn>
              <v-btn block color="#424242" dark @click="lockRegion1()" v-else>
                <v-icon dark left>lock_open</v-icon>三田のロックを解除する
              </v-btn>
            </v-flex>
          </v-layout>

          <v-layout row wrap reverse v-if="!isZumiUser">
            <v-flex xs12 sm3 style="margin-right: 20px;">
              <p class="font-italic caption">最終更新: {{ region2UpdatedAt }} {{ region2UpdatedUser }}</p>
            </v-flex>
            <v-flex xs12 sm3 style="margin-right: 30px;">
              <p class="font-italic caption">最終更新: {{ region1UpdatedAt }} {{ region1UpdatedUser }}</p>
            </v-flex>
          </v-layout>

          <v-flex xs12>
            <div style="height: 30px;"></div>
          </v-flex>

          <v-flex xs12 v-if="!isZumiUser">
            <v-textarea outline label="備考" v-model="remarks"></v-textarea>
          </v-flex>

          <v-layout row wrap reverse justify-center>
            <v-flex xs12 sm12 style="margin: 40px 20px 20px;">
              <v-btn 
                v-if="!isZumiUser"
                block 
                color="error" 
                dark 
                @click="fixOrder()"
              >
                <v-icon dark left>save</v-icon>注文受付を確定する
              </v-btn>
            </v-flex>
            <v-flex xs12 sm3 v-if="!isZumiUser">
              <p class="font-italic caption">最終更新: {{ updatedAt }} {{ updatedUser }}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <v-card v-if="!isZumiUser">
        <v-container>
          <v-card-title>納品書出力</v-card-title>

          <v-layout row wrap reverse justify-center>
            <v-flex xs12 sm12>
              <v-btn
                block
                color="primary"
                dark
                :to="{
                  name: 'admin/delivery-slip',
                  params: { orderManagementId: this.orderManagementId }
                }"
              >
                <v-icon dark left>get_app</v-icon>納品書を出力する
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-card v-if="!isZumiUser">
        <v-container>
          <v-card-title>伝票番号入力</v-card-title>

          <v-layout row wrap>
            <v-flex xs12 sm6 style="margin-right: 20px;">            
              <v-text-field
                v-model="slipNumber"
                label="伝表番号"
                outline
                clearable
                required
                style="font-size: 20px;"
              ></v-text-field>
            </v-flex>
            <v-flex xs3 sm2 style="margin-right: 30px;" v-if="updateLoading">
              <v-btn block color="warning" @click="updateStockQuantity1()" >
                <v-icon left>save</v-icon>七井土在庫に反映する
              </v-btn>
            </v-flex>
            <v-flex xs3 sm2 style="margin-right: 30px;" v-if="updateLoading">
              <v-btn block color="blue" @click="updateStockQuantity2()" >
                <v-icon left>save</v-icon>中の島在庫に反映する
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm12 style="margin: 0 0 20px 0;">
              <v-btn block color="error" dark @click="registSlipNumber()">
                <v-icon dark left>save</v-icon>伝票番号を登録する
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-order-confirm' }">
            <v-icon dark left>arrow_back</v-icon>{{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <div style="height: 35px;"></div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    console.log('created')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    this.orderConfirmSelectedShippingDate = this.adminSession.orderConfirmSelectedShippingDate
    this.orderManagementId = this.adminSession.orderAcceptOrderManagementId

    window.sessionStorage.setItem('warehouseId', '14')
    
    // 치바 재고반영 버튼 표시/ 비표시
    let request = { orderManagementId: this.orderManagementId }
    ServerApiCallService.getStockLock(request)
    .then(response => {
      // 버튼을 누른적이 있으면 true/ 없으면 falsd
      if(response.data) {
        this.updateLoading = false;
      } else {
        this.updateLoading = true;
      }
    })
    .catch(error => {
      this.updateLoading = true;
    })    
  
    this.getOrderDetail()
  },
  methods: {
    getOrderDetail() {
      let thisObj = this
      let request = {
        orderManagementId: this.orderManagementId
      }

      ServerApiCallService.orderDetailsByDay(request)
        .then(response => {
          this.storeCode = response.data.storeCode
          this.storeName = response.data.storeName
          this.orderCreatedUser = response.data.createdUser

          window.sessionStorage.setItem('storeCode', this.storeCode)

          // this.shippingDate =
          //   response.data.shippingDate.substring(0, 4) +
          //   '/' +
          //   response.data.shippingDate.substring(4, 6) +
          //   '/' +
          //   response.data.shippingDate.substring(6, 8)

          thisObj.orderDetails = response.data.orderDetails

          thisObj.orderDetails.sort(function(a, b) {
            if (a.itemName > b.itemName) return 1
            if (a.itemName < b.itemName) return -1
            // a must be equal to b
            return 0
          })
          thisObj.orderDetails.sort(function(a, b) {
            if (a.itemCategoryId > b.itemCategoryId) return 1
            if (a.itemCategoryId < b.itemCategoryId) return -1
            // a must be equal to b
            return 0
          })
          thisObj.slipNumber = response.data.slipNumber

          thisObj.region1IsLocked = response.data.region1IsLocked
          thisObj.region1UpdatedUser = response.data.region1UpdatedUser
          if (response.data.region1UpdatedAt != null) {
            thisObj.region1UpdatedAt =
              response.data.region1UpdatedAt.substring(0, 4) +
              '/' +
              response.data.region1UpdatedAt.substring(4, 6) +
              '/' +
              response.data.region1UpdatedAt.substring(6, 8) +
              ' ' +
              response.data.region1UpdatedAt.substring(8, 10) +
              ':' +
              response.data.region1UpdatedAt.substring(10, 12)
          }
          thisObj.region2IsLocked = response.data.region2IsLocked
          thisObj.region2UpdatedUser = response.data.region2UpdatedUser
          if (response.data.region2UpdatedAt != null) {
            thisObj.region2UpdatedAt =
              response.data.region2UpdatedAt.substring(0, 4) +
              '/' +
              response.data.region2UpdatedAt.substring(4, 6) +
              '/' +
              response.data.region2UpdatedAt.substring(6, 8) +
              ' ' +
              response.data.region2UpdatedAt.substring(8, 10) +
              ':' +
              response.data.region2UpdatedAt.substring(10, 12)
          }
          if (response.data.updatedAt != null) {
            thisObj.updatedAt =
              response.data.updatedAt.substring(0, 4) +
              '/' +
              response.data.updatedAt.substring(4, 6) +
              '/' +
              response.data.updatedAt.substring(6, 8) +
              ' ' +
              response.data.updatedAt.substring(8, 10) +
              ':' +
              response.data.updatedAt.substring(10, 12)
            thisObj.updatedUser = response.data.updatedUser
          }
          thisObj.hasImage = response.data.hasImage
          thisObj.remarks = response.data.remarks
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    lockRegion1() {
      console.log('lock region1')

      if (this.isZumiUser) {
        return
      }

      let thisObj = this
      let requestRegion1IsLocked = this.region1IsLocked === '1' ? '0' : '1' // 変更後のロック状態

      let request = {
        // storeCode: this.storeCode,
        // shippingDate: this.shippingDate.replace(/\//g, ''),
        orderManagementId: this.orderManagementId,
        region1IsLocked: requestRegion1IsLocked
      }
      ServerApiCallService.orderLockRegion1(request)
        .then(response => {
          thisObj.region1IsLocked = response.data.region1IsLocked
          thisObj.region1UpdatedUser = response.data.region1UpdatedUser
          thisObj.region1UpdatedAt = response.data.region1UpdatedAt
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    lockRegion2() {
      console.log('lock region2')

      if (this.isZumiUser) {
        return
      }

      let thisObj = this
      let requestRegion2IsLocked = this.region2IsLocked === '1' ? '0' : '1' // 変更後のロック状態

      let request = {
        // storeCode: this.storeCode,
        // shippingDate: this.shippingDate.replace(/\//g, ''),
        orderManagementId: this.orderManagementId,
        region2IsLocked: requestRegion2IsLocked
      }
      ServerApiCallService.orderLockRegion2(request)
        .then(response => {
          thisObj.region2IsLocked = response.data.region2IsLocked
          thisObj.region2UpdatedUser = response.data.region2UpdatedUser
          thisObj.region2UpdatedAt = response.data.region2UpdatedAt
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    fixOrder() {
      console.log('fix order')

      if (this.isZumiUser) {
        return
      }

      let request = {
        orderManagementId: this.orderManagementId,
        remarks: this.remarks,
        orderDetails: this.orderDetails
      }

      let sendContext = {
        hasDialogComponent: this.$parent.$parent.$parent
        // forwardNameOnClose: 'admin/new-order-confirm'
      }

      ServerApiCallService.fixOrder(request, sendContext)
        .then(response => {
          this.getOrderDetail()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    registSlipNumber() {
      console.log('regist slip number')

      if (this.isZumiUser) {
        return
      }

      // var regex = RegExp(/^[0-9;]*$/)
      // if (!regex.test(this.slipNumber)) {
      //   this.$parent.$parent.$parent.showErrorDialog(
      //     '伝表番号が正しくありません'
      //   )
      //   return
      // }

      let request = {
        orderManagementId: this.orderManagementId,
        slipNumber: this.slipNumber
      }

      ServerApiCallService.orderRegistSlipNumber(request)
        .then(response => {})
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    downloadOrderImage() {
      console.log('download order image')

      if (this.isZumiUser) {
        return
      }

      let request = {
        orderManagementId: this.orderManagementId
      }

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/download-order/' + this.orderManagementId, {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'image/jpg' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'image.jpg'
          link.click()
        })
    },
    onChangeRegion(changedItem) {
      if (this.isZumiUser) {
        return
      }

      console.log('change region')

      if (changedItem.region1 < 0 || changedItem.region2 < 0) {
        this.$parent.$parent.$parent.showResultDialog(
          this.$t('sales.minus-quantity'),
          null,
          true
        )
      }

      let regionSum =
        parseInt(changedItem.region1) + parseInt(changedItem.region2)
      if (regionSum > changedItem.orderLimitNumber) {
        this.$parent.$parent.$parent.showResultDialog(
          '三田と千葉の合計値が調整数を超えています。',
          null,
          true
        )
      }
      changedItem.numberOfAdjustments =
        parseInt(changedItem.region1) + parseInt(changedItem.region2)
      changedItem.isChanged = true
    },
    changeShippingDate() {
      console.log('change shipping date')
      this.changedShippingDate = this.shippingDateForPicker.replace(/-/g, '/')
    },
    updateShippingDate() {      
      if (this.isZumiUser) {
        return
      }

      if (this.changedShippingDate === '') {
        this.$parent.$parent.$parent.showErrorDialog(
          this.$t('sales.non-selected-shipping-date')
        )
        return
      }

      let request = {
        orderManagementId: this.orderManagementId,
        shippingDate: this.changedShippingDate.replace(/\//g, '')
      }

      ServerApiCallService.changeShippingDate(request)
        .then(response => {
          this.orderConfirmSelectedShippingDate = this.changedShippingDate
          this.changedShippingDate = ''
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    customFilter(items, search) {
      if (search === false) {
        return items
      } else {
        return items.filter(item => item.quantity > 0)
      }
    },
    copyOrderRequest() {
      if (this.isZumiUser) {
        return
      }

      if (this.region2IsLocked == '1') {
        return
      }
      this.orderDetails.forEach(function(orderDetail) {
        if (orderDetail.quantity > 0) {
          orderDetail.region2 = orderDetail.quantity
        }
      })
    },
    clearOrderDetail(item) {
      console.log('clear order detail')

      if (this.isZumiUser) {
        return
      }

      let request = {
        orderDetailId: item.orderDetailId
      }

      ServerApiCallService.clearOrderDetail(request)
        .then(response => {
          item.region1 = 0
          item.region2 = 0
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    updateStockQuantity1() {
      if (this.isZumiUser) {
        return
      }

      if (!confirm("千葉七井土の在庫に反映しますか")) {
        return;
      }

      let request =[];
      for (let i=0; i<this.orderDetails.length; i++) {
        if (this.orderDetails[i].region2 == 0) {
          continue;
        } else {
          let obj = {
            warehouseId: '14', // 七井土
            itemCode: this.orderDetails[i].itemCode,
            stockQuantity: this.orderDetails[i].region2,
            orderManagementId: this.orderManagementId,
            type: "calculate"
          }

          request.push(obj);
        }
      }
      
      ServerApiCallService.updateStockQuantity(request)
      .then(response => {
        // 버튼을 비활성화
        this.updateLoading = false;
      })
      .catch(error => {
        this.updateLoading = true;
      })
    },
    updateStockQuantity2() {
      if (this.isZumiUser) {
        return
      }

      if (!confirm("千葉中の島の在庫に反映しますか")) {
        return;
      }

      let request =[];
      for (let i=0; i<this.orderDetails.length; i++) {
        if (this.orderDetails[i].region2 == 0) {
          continue;
        } else {
          let obj = {
            warehouseId: '21', // 中の島
            itemCode: this.orderDetails[i].itemCode,
            stockQuantity: this.orderDetails[i].region2,
            orderManagementId: this.orderManagementId,
            type: "calculate"
          }

          request.push(obj);
        }
      }
      
      ServerApiCallService.updateStockQuantity(request)
      .then(response => {
        // 버튼을 비활성화
        this.updateLoading = false;
      })
      .catch(error => {
        this.updateLoading = true;
      })
    }
  },  
  computed: {
    ...mapState({
      user: state => state.user,
      adminSession: state => state.adminSession
    }),

    isZumiUser() {
      const authority = this.user && this.user.adminRole
      return String(authority) === '9'
    },

    storeName: {
      get() {
        let storeName = this.$store.state.adminSession
          .orderAcceptSelectedStoreName
        return storeName
      },
      set(value) {
        this.$store.commit('SET_ORDER_ACCEPT_SELECTED_STORE_NAME', value)
      }
    }
  },
  data() {
    return {
      orderManagementId: '',
      orderCreatedUser: '',
      // shippingDate: '',
      storeCode: '',
      region1IsLocked: '',
      region1UpdatedUser: '',
      region1UpdatedAt: '',
      updatedAt: '',
      updatedUser: '',
      slipNumber: '',

      region2IsLocked: '',
      region2UpdatedUser: '',
      region2UpdatedAt: '',
      orderDetails: [],
      hasImage: false,
      menu2: false,
      shippingDateForPicker: '',
      changedShippingDate: '',
      orderConfirmSelectedShippingDate: '',
      remarks: '',
      isOrderedItems: true,
      updateLoading: true,
      headers: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '200px',
          fixed: true,
          class: 'px-3'
        },
        {
          text: '発注数',
          align: 'right',
          sortable: false,
          value: 'quantity',
          width: '50px',
          fixed: true,
          class: 'px-3'
        },
        {
          text: '在庫数',
          align: 'right',
          sortable: false,
          value: 'carbsnumberOfStocks',
          width: '30px',
          class: 'px-3'
        },
        {
          text: '発注制限数',
          align: 'right',
          sortable: false,
          value: 'orderLimitNumber',
          width: '30px',
          class: 'px-3'
        },
        {
          text: '調整数',
          align: 'right',
          sortable: false,
          value: 'numberOfAdjustments',
          width: '30px',
          class: 'px-3'
        },
        {
          text: '三田',
          align: 'right',
          sortable: false,
          value: 'region1',
          width: '30px',
          class: 'px-3'
        },
        {
          text: '千葉',
          align: 'right',
          sortable: false,
          value: 'region2',
          width: '30px',
          class: 'px-3'
        },
        {
          text: '',
          align: 'right',
          sortable: false,
          value: 'clear',
          width: '30px',
          class: 'px-3'
        }
      ]
    }
  }
}
</script>

<style>
.region-is-locked {
  background-color: #adadad;
}
tr.changed-class-name-order-accept.changed-over-class-name-order-accept,
.theme--light.v-table
  tbody
  tr.changed-over-class-name-order-accept.changed-class-name-order-accept:hover:not(.v-datatable__expand-row) {
  background-color: #ff6262 !important;
}
tr.changed-class-name-order-accept,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #d0e0ff;
}

.column-input-for-order {
  width: 55px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
}
.item-name-column {
  font-size: 14px !important;
  /*  width: 300px !important;*/
}
.number-column.text-xs-right {
  font-size: 16px !important;
  padding: 0 10px !important;
}
th.number-column.text-xs-right {
  padding: 0 10px !important;
  white-space: pre-wrap !important;
  /*  width: 50px !important;*/
}
td.number-column.text-xs-right {
  padding: 0 10px 0 0 !important;
  /*  width: 50px !important;*/
}
.number-column.text-xs-right {
  text-align: right !important;
}
</style>
